import { LayoutHeader } from "@/Header";
import { Tabs } from "@/Tabs";
import { useTab } from "^/common/useTab";
import { createFileRoute } from "@tanstack/react-router";
import NotifyReceived from "@/business/notify/NotifyReceived";
import NotifySent from "@/business/notify/NotifySent";
import NotifySaved from "@/business/notify/NotifySaved";
import { useBusinessNoticeHasNewReply } from "~/services/business/notice";
import { useEffect, useState } from "react";
import { useBusinessNotifyStore } from "&/businessNotifyList";
// import { useAppExit } from "^/common/useAppExit";
// import { AppExitDialog } from "@/AppExitDialog";

export const Route = createFileRoute("/business/layout/notify")({
  component: Notify,
});

function Notify() {
  // 상세에서 뒤로 돌아온 경우 저장해둔 탭으로 복원 (목록/스크롤 복원은 각 탭 컴포넌트가 처리)
  const [restoredTab] = useState(() => {
    const s = useBusinessNotifyStore.getState();
    return s.returning && s.snapshot ? s.snapshot.tab : undefined;
  });

  const { tab, handleTab, tabList } = useTab(
    ["받은 알림장", "보낸 알림장", "저장 알림장"],
    restoredTab
  );

  // 복원 플래그 소비 (1회성 — 이후 일반 진입은 새로 조회)
  // 자식 탭 컴포넌트의 useState 초기화(렌더 중)가 끝난 뒤에 실행되므로 안전
  useEffect(() => {
    useBusinessNotifyStore.getState().consume();
  }, []);

  // 새로운 댓글 상태 확인 API 호출
  const { data: newReplyData, refetch } = useBusinessNoticeHasNewReply();

  // 탭이 변경될 때마다 API 재호출
  useEffect(() => {
    refetch();
  }, [tab, refetch]);

  // 새로운 댓글 표시 플래그 생성
  const newReplyFlags = [
    newReplyData?.data?.hasRecipientNewReply || false, // 받은 알림장
    newReplyData?.data?.hasSenderNewReply || false, // 보낸 알림장
    false, // 저장 알림장 (새로운 댓글 표시 없음)
  ];

  // const { showExitDialog, hideExitConfirmation, confirmAppExit } = useAppExit();

  return (
    <>
      <LayoutHeader title={tab} hasFootPrint={false} />
      <div className="flex-auto bg-[#F5F5F5]">
        <Tabs
          tabList={tabList}
          handleTab={handleTab}
          tab={tab}
          newReplyFlags={newReplyFlags}
        >
          <NotifyReceived />
          <NotifySent />
          <NotifySaved />
        </Tabs>
      </div>

      {/* <AppExitDialog
        visible={showExitDialog}
        onConfirm={confirmAppExit}
        onCancel={hideExitConfirmation}
      /> */}
    </>
  );
}

// const dummy = [
//   {
//     key: "1",
//     kind: "notice",
//     title: "또치 알림장이 도착했어요.",
//     type: "calendar",
//     petName: "또치",
//     petType: "강아지",
//     petImg: pet1Src,
//     petWeight: "20kg",
//     date: "2024.05.05 13:00",
//     read: true,
//     img: [],
//     text: "안녕하세요. 오늘 우리 또치는 사료도 잘먹고 어질리티 훈련을 잘받았어요. 간식으로 오후에 닭발을 먹었어요 오후에 운동장에서 뛰어놀고 다른 강아지와 함께 물놀이에도 참여했어요. 낮잠은 실내 캔넬에서 1시간가량 잤어요.",
//   },
//   {
//     key: "2",
//     kind: "notice",
//     title: "또치 알림장이 도착했어요.",
//     type: "calendar",
//     petName: "또치",
//     petType: "강아지",
//     petWeight: "10kg",
//     date: "2024.05.05 13:00",
//     petImg: pet1Src,
//     read: false,
//     img: [],
//     text: "안녕하세요.\n오늘 우리 또치는 사료도 잘먹고 어질리티 훈련을 잘받았어요. 간식으로 오후에 닭발을 먹었어요 오후에 운동장에서 뛰어놀고 다른 강아지와 함께 물놀이에도 참여했어요. 낮잠은 실내 캔넬에서 1시간가량 잤어요.",
//   },
//   {
//     key: "3",
//     kind: "notice",
//     title: "또치 알림장이 도착했어요.",
//     type: "notify",
//     petName: "또치",
//     petType: "강아지",
//     petWeight: "30kg",
//     date: "2024.05.05 13:00",
//     petImg: pet1Src,
//     read: true,
//     img: [pet1Src, pet1Src],
//     text: "안녕하세요.\n오늘 우리 또치는 사료도 잘먹고 어질리티 훈련을 잘받았어요. 간식으로 오후에 닭발을 먹었어요 오후에 운동장에서 뛰어놀고 다른 강아지와 함께 물놀이에도 참여했어요. 낮잠은 실내 캔넬에서 1시간가량 잤어요.",
//   },
// {
//   kind: "notice",
//   title: "사진첩이 업데이트되었어요.",
//   type: "notify",
//   read: true,
//   img: [pet1Src, pet1Src],
//   text: null,
// },
// {
//   kind: "reservation",
//   title: "유치원에서 예약정보를 변경했어요.",
//   type: "calendar",
//   read: false,
//   img: [],
//   text: "해당 예약 시간에 시설 안전점검 일정이 있어 예약 시간을 조정했습니다.\n예약 취소는 00일 이내에 가능합니다.",
// },
// {
//   kind: "reservation",
//   title: "유치원에서 예약정보를 변경했어요.",
//   type: "calendar",
//   read: true,
//   img: [],
//   text: "해당 예약 시간에 시설 안전점검 일정이 있어 예약 시간을 조정했습니다.\n예약 취소는 00일 이내에 가능합니다.",
// },
// {
//   kind: "reservation",
//   title: "유치원에서 예약정보를 변경했어요.",
//   type: "calendar",
//   read: false,
//   img: [],
//   text: "해당 예약 시간에 시설 안전점검 일정이 있어 예약 시간을 조정했습니다.\n예약 취소는 00일 이내에 가능합니다.",
// },
// ];
